"use client";

import { FitnessScoreCard } from "./FitnessScoreCard";
import type { FitnessScoreCardProps } from "./types";
import { useFitnessScoreCardNavigation } from "./useFitnessScoreCardNavigation";

export function FitnessScoreCardRegistryEntry({
  props,
}: {
  props: Omit<FitnessScoreCardProps, "onSeeFullScore">;
}) {
  const { onSeeFullScore } = useFitnessScoreCardNavigation({
    total: props.total,
    delta: props.delta,
  });

  return <FitnessScoreCard {...props} onSeeFullScore={onSeeFullScore} />;
}
